import type { MarketConfiguration } from "./const";
import {
  ContentfulEnum,
  CurrencyEnum,
  ElevateMarketEnum,
  LocaleEnum,
  MarketEnum,
  RegionEnum,
  ServiceLocaleEnum,
} from "./const";

const czechia: MarketConfiguration = {
  code: MarketEnum.cz,
  label: "Czech Republic",
  descriptiveLabel: "Czech",
  contentfulLocale: ContentfulEnum.en,
  contentfulCountry: "Czechia",
  locale: LocaleEnum.cz,
  serviceLocale: ServiceLocaleEnum.cz,
  language: {
    code: "en",
    label: "English",
    flag: "gb",
  },
  currency: CurrencyEnum.eur,
  link: "https://www.no-ga.com/en-cz",
  termsSlug: "terms-online",
  loop54Market: MarketEnum.cz,
  adyenMarket: MarketEnum.cz,
  elevateMarket: ElevateMarketEnum.eu,
  freeShippingThreshold: 100,
  freeShippingEnabled: false,
  externalStoreId: "ecom-noga",
  searchPathName: "search",
  adyenCheckoutEnabled: true,
  walleyCheckoutEnabled: false,
  hasTrustPilot: false,
  region: RegionEnum.europe,
  norceImageCdn: ["local", "dev", "stage"].includes(
    process.env.NEXT_PUBLIC_ENVIRONMENT ?? "",
  )
    ? "https://media.stage.cdn-norce.tech/1413"
    : "https://cdn.no-ga.com",
};

export default czechia;
